import { Markdown as CommonMarkdown } from '@topwrite/common';
import { ComponentProps, useEffect } from 'react';
import { history } from '@/lib/history';
import Img from './html/img';
import Attachment from './html/attachment';
import Video from './html/video';
import Audio from './html/audio';
import A from './html/a';
import Heading from './html/heading';
import useCss from '@/lib/use-css';

type MarkdownProps = ComponentProps<typeof CommonMarkdown>

const components = {
    a: A,
    img: Img,
    attachment: Attachment,
    video: Video,
    audio: Audio,
    heading: Heading,
};

export default function Markdown({ children, ...props }: MarkdownProps) {

    useEffect(() => {
        const hash = history.location.hash;
        if (hash) {
            const anchor = document.getElementById(decodeURIComponent(hash).substr(1));
            if (anchor) {
                window.scrollTo(0, anchor.offsetTop);
            }
        }
    }, []);

    const css = useCss();

    return <CommonMarkdown css={css} {...props} components={components}>
        {children}
    </CommonMarkdown>;
}
